module.exports = __webpack_public_path__ + "img/MTABAPP6MWT.eb7a781d.jpg";